import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import { SidebarProvider } from './context/SidebarContext';
import AuthProvider from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './pages/Login';
import DashboardEnhanced from './pages/DashboardEnhanced';
import EmployeeList from './pages/EmployeeList';
import EmployeeFormComprehensive from './pages/EmployeeFormComprehensive';
import EmployeeProfile from './pages/EmployeeProfile';
import ColorPalette from './pages/ColorPalette';
import Departments from './pages/Departments';
import AttendanceWithCamera from './pages/AttendanceWithCamera';
import Leaves from './pages/Leaves';
import Payroll from './pages/Payroll';
import Performance from './pages/Performance';
import Documents from './pages/Documents';
import Announcements from './pages/Announcements';
import Onboarding from './pages/Onboarding';
import Shifts from './pages/Shifts';
import Holidays from './pages/Holidays';
import Assets from './pages/Assets';
import HRPolicies from './pages/HRPolicies';
import TravelExpense from './pages/TravelExpense';
import Legal from './pages/Legal';
import RoleManagement from './pages/RoleManagement';
import Reports from './pages/Reports';
import PricingDiscussion from './pages/PricingDiscussion';
import ProductManagement from './pages/ProductManagement';
import ProductDetail from './pages/ProductDetail';
import HRMSDashboard from './pages/HRMSDashboard';
import FranchiseeManagementUnified from './pages/FranchiseeManagementUnified';
import StoreOperations from './pages/StoreOperations';
import StoreSetup from './pages/StoreSetup';
import VendorRegistration from './pages/VendorRegistration';
import SupplierManagement from './pages/SupplierManagement';
import PurchaseManagement from './pages/PurchaseManagement';
import FinanceManagement from './pages/FinanceManagement';
import CMS from './pages/CMS';
import Orders from './pages/Orders';
import ShellPage from './components/ShellPage';

function App() {
  return (
    <AuthProvider>
      <SidebarProvider>
        <BrowserRouter>
          <Routes>
            {/* Auth Routes */}
            <Route path="/login" element={<Login />} />
            
            {/* Protected Routes */}
            <Route 
              path="/" 
              element={
                <ProtectedRoute>
                  <DashboardEnhanced />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/employees" 
              element={
                <ProtectedRoute>
                  <EmployeeList />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/employees/new" 
              element={
                <ProtectedRoute>
                  <EmployeeFormComprehensive />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/employees/:id" 
              element={
                <ProtectedRoute>
                  <EmployeeProfile />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/employees/:id/edit" 
              element={
                <ProtectedRoute>
                  <EmployeeFormComprehensive />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/color-palette" 
              element={
                <ProtectedRoute>
                  <ColorPalette />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/departments" 
              element={
                <ProtectedRoute>
                  <Departments />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/attendance" 
              element={
                <ProtectedRoute>
                  <AttendanceWithCamera />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/leaves" 
              element={
                <ProtectedRoute>
                  <Leaves />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/payroll" 
              element={
                <ProtectedRoute>
                  <Payroll />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/performance" 
              element={
                <ProtectedRoute>
                  <Performance />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/documents" 
              element={
                <ProtectedRoute>
                  <Documents />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/announcements" 
              element={
                <ProtectedRoute>
                  <Announcements />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/onboarding" 
              element={
                <ProtectedRoute>
                  <Onboarding />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/shifts" 
              element={
                <ProtectedRoute>
                  <Shifts />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/holidays" 
              element={
                <ProtectedRoute>
                  <Holidays />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/assets" 
              element={
                <ProtectedRoute>
                  <Assets />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/hr-policies" 
              element={
                <ProtectedRoute>
                  <HRPolicies />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/travel-expense" 
              element={
                <ProtectedRoute>
                  <TravelExpense />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/legal" 
              element={
                <ProtectedRoute>
                  <Legal />
                </ProtectedRoute>
              } 
            />
            <Route path="/role-management" element={<Navigate to="/rbac" replace />} />
            <Route 
              path="/reports" 
              element={
                <ProtectedRoute>
                  <Reports />
                </ProtectedRoute>
              } 
            />
            <Route path="/pricing-discussion" element={<Navigate to="/pricing" replace />} />
            <Route path="/product-management" element={<Navigate to="/products" replace />} />
            <Route path="/products" element={<ProtectedRoute><ProductManagement /></ProtectedRoute>} />
            <Route path="/pricing" element={<ProtectedRoute><ShellPage component={PricingDiscussion} /></ProtectedRoute>} />
            <Route path="/orders" element={<ProtectedRoute><ShellPage component={Orders} /></ProtectedRoute>} />
            <Route 
              path="/products/:id" 
              element={
                <ProtectedRoute>
                  <ProductDetail />
                </ProtectedRoute>
              } 
            />
            <Route path="/hrms-dashboard" element={<Navigate to="/hrms" replace />} />
            <Route path="/hrms" element={<ProtectedRoute><HRMSDashboard /></ProtectedRoute>} />
            <Route path="/franchisee-management" element={<Navigate to="/franchisee" replace />} />
            <Route path="/franchisee" element={<ProtectedRoute><FranchiseeManagementUnified /></ProtectedRoute>} />
            <Route path="/rbac" element={<ProtectedRoute allowedRoles={['Admin', 'SuperAdmin']}><RoleManagement /></ProtectedRoute>} />
            <Route 
              path="/store-operations" 
              element={
                <ProtectedRoute>
                  <StoreOperations />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/store-setup" 
              element={
                <ProtectedRoute>
                  <StoreSetup />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/vendor-registration" 
              element={<VendorRegistration />}
            />
            <Route 
              path="/supplier-management" 
              element={
                <ProtectedRoute>
                  <SupplierManagement />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/purchase-management" 
              element={
                <ProtectedRoute>
                  <PurchaseManagement />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/finance-management" 
              element={
                <ProtectedRoute>
                  <FinanceManagement />
                </ProtectedRoute>
              } 
            />
            <Route
              path="/cms"
              element={
                <ProtectedRoute allowedRoles={['Admin', 'SuperAdmin']}>
                  <CMS />
                </ProtectedRoute>
              }
            />
            
            {/* Catch all - redirect to home */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </SidebarProvider>
    </AuthProvider>
  );
}

export default App;
